export enum CourseType {
  DirectEntry = 'Direct Entry',
  DirectEntryWaiver = 'Direct Entry Waiver',
  DEW = 'DEW',
  Pathway = 'Pathway',
  ICAS = 'iCAS',
  IntegratedMasterProgram = 'Integrated Masters Program',
  IntegratedMastersProgram = "Integrated Master's Program",
  InternationalDirect = 'International Direct',
  MastersInternationalDirect = "Master's International Direct",
  SupportedDirectEntry = 'SupportedDirectEntry',
  ALevel = 'A-level',
  Others = 'Direct Entry (ID, IMP & MID only)',
}
